import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 16,
    },
    line: {
      flexGrow: 1,
      borderBottom: `1px solid ${color.$9}`,
    },
    text: {
      margin: '0 16px',
      maxWidth: '80%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: color.$11,
    },
    order: { display: 'flex', alignItems: 'center', marginBottom: 24 },
    couponName: {
      width: '100%',
      textAlign: 'center',
      color: color.$13,
      fontSize: '15px',
      lineHeight: '21px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  {
    name: 'PreviewCouponNode',
  },
);

const PreviewCouponNode = ({ node }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data } = node || {};
  const { couponName, couponId } = data || {};

  if (!couponId) return null;

  return (
    <div className={classes.root}>
      <div className={classes.order}>
        <span className={classes.line} />
        <span className={classes.text}>{t('add-coupon')}</span>
        <span className={classes.line} />
      </div>
      <div className={classes.couponName}>
        {t('coupon.preview', { couponName })}
      </div>
    </div>
  );
};

export default PreviewCouponNode;
